function refresh() {
    window.location.reload()
}

export default refresh
